import $ from 'jquery';

export default () => {
    const header = $('.js-site-header');
    const trigger = $('.js-site-header-trigger');
    const nav = $('.js-site-nav');
    const notice = $('.js-header-notice');
    const noticeClose = $('.js-header-notice-close');
    const offset = 300;

    function setHeaderHeight() {
        const root = document.documentElement;
        const headerHeight = header.outerHeight();

        root.style.setProperty('--site-header-height', headerHeight + 'px');
    }

    setHeaderHeight();

    $(window).on('resize', setHeaderHeight);

    const headroom = new Headroom(header[0], {
        offset: offset,
    });
    headroom.init();

    trigger.on('click', function() {
        $(this).add(nav).add(header).toggleClass('is-active');
    });

    noticeClose.on('click', function() {
        notice.removeClass('is-active');
        setHeaderHeight();
    });
}



// WEBPACK FOOTER //
// ../src/scripts/modules/header.js